let BASEURL = 'https://lease.api.apps.rabahrain.com';
let FINANCE_URL = 'https://apinew.apps.rabahrain.com';
let AGENT_URL = 'https://leasefinanceapi.apps.rabahrain.com';
export const endPoint = {
  GET_UNITNO_DATA: `${BASEURL}/api/LeaseCommon/GetCommonData`,
  GET_CUSTOMER_LAZY_NAME: `${BASEURL}/api/LeaseCommon/GetCustomersByName`,
  GET_CURRENCY_PER: `${FINANCE_URL}/api/finance/currencies/listing`,

  // Dashboard
  GET_DASHBOARD_LIST: `${BASEURL}/api/LeaseDashboard/GetDashboardUnits`,
  GET_DASHBOARD_DROP: `${BASEURL}/api/LeaseDashboard/GetMultipleDropdown`,
  GET_DASHBOARD_CASCAD: `${BASEURL}/api/LeaseDashboard/GetCascadDropdown`,
  GET_DASHBOARD_STATS: `${BASEURL}/api/LeaseDashboard/GetDashboardStats`,

  // Customer Master
  GET_CUSTOMER: `${BASEURL}/api/Customer/Get`,
  POST_CUSTOMER: `${BASEURL}/api/Customer/CreateCustomer`,
  DELETE_CUSTOMER: `${BASEURL}/api/Customer/GetCommonData`,
  EDIT_CUSTOMER: `${BASEURL}/api/Customer/EditCustomer`,
  CUSTOMER_CASCAD: `${BASEURL}/api/Customer/GetCascadDropdown`,
  CUSTOMER_COMMON: `${BASEURL}/api/Customer/GetCommonData`,
  CUSTOMER_MULTI: `${BASEURL}/api/Customer/GetMultipleDropdown`,

  // Unit Master
  GET_UNIT_LIST: `${BASEURL}/api/UnitManagement/GetAll`,
  GET_UNIT_ID: `${BASEURL}/api/UnitManagement/GetById/`,
  GET_UNIT_MULTIDROP: `${BASEURL}/api/UnitManagement/GetMultipleDropdown`,
  GET_UNIT_CASCAD: `${BASEURL}/api/UnitManagement/GetCascadDropdown`,
  CREATE_UNIT: `${BASEURL}/api/UnitManagement/Create`,
  UPDATE_UNIT: `${BASEURL}/api/UnitManagement/Update`,
  DELETE_UNIT: `${BASEURL}/api/UnitManagement/Delete/`,
  GET_UNIT_COMMON: `${BASEURL}/api/UnitManagement/GetCommonData`,
  POST_UNIT_ADDITIONAL: `${BASEURL}/api/UnitManagement/InsertAllAdditionalDetails`,

  // Unit Release (Unit Blocking)
  GET_UNIT_BLOCKING_LIST: `${BASEURL}/api/UnitBlocking/GetAllUnitBlockings`,
  GET_UNIT_BLOCKING_BY_ID: `${BASEURL}/api/UnitBlocking/GetUnitBlockingById/`,
  RELEASE_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/ReleaseUnitBlocking`,
  GET_UNIT_BLOCKING_MULTIDROP: `${BASEURL}/api/UnitBlocking/GetMultipleDropdown`,

  // Unit Block / Unit Release listing page (unitBlock/listing.js)
  UNITBLOCKING_MULTIDROP: `${BASEURL}/api/UnitBlocking/GetMultipleDropdown`,
  GET_ALL_UNIT_BLOCKINGS: `${BASEURL}/api/UnitBlocking/GetAllUnitBlockings`,
  GET_ALL_UNIT_BLOCKINGS_RELEASE: `${BASEURL}/api/UnitBlocking/GetAllUnitBlockingsRelease`,
  BULK_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/BulkUnitBlocking`,
  BULK_RELEASE_UNIT_BLOCKING: `${BASEURL}/api/UnitBlocking/BulkReleaseUnitBlocking`,

  // Property Master
  GET_PROPERTY_LIST: `${BASEURL}/api/Property/GetAll`,
  POST_PROPERTY: `${BASEURL}/api/Property/CreateProperty`,
  UPDATE_PROPERTY: `${BASEURL}/api/Property/EditProperty`,
  PROPERTY_MULTIDROP: `${BASEURL}/api/Property/GetMultipleDropdown`,
  PROPERTY_CASCAD: `${BASEURL}/api/Property/GetCascadDropdown`,
  PROPERTY_COMMON_DATA: `${BASEURL}/api/Property/GetCommonData`,
  DELETE_PROPERTY: `${BASEURL}/api/Property/DeleteProperty`,
  GET_PROPERTY_BY_ID: `${BASEURL}/api/Property/GetPropertyById`,
  UPLOAD_PROPERTY_IMAGE: `${BASEURL}/api/Property/AddPropertyImage`,
  DELETE_PROPERTY_IMAGE: `${BASEURL}/api/Property/DeletePropertyImage`,
  GET_PROPERTY_IMAGE: `${BASEURL}/api/Property/GetPropertyImages`,

  // File Upload
  UNIT_FILE: `${BASEURL}/api/FileUpload/files`,
  GET_FILE: `${BASEURL}/api/FileUpload/list`,
  DELETE_FILE: `${BASEURL}/api/FileUpload/delete`,

  // Unit Release RA (frmUnitRelease migration - releases blocked/reserved/sold/leased units)
  UNIT_RELEASE_RA_DROPDOWNS: `${BASEURL}/api/UnitReleaseRA/GetDropdowns`,
  UNIT_RELEASE_RA_SETTINGS: `${BASEURL}/api/UnitReleaseRA/GetSettings`,
  UNIT_RELEASE_RA_UNITS: `${BASEURL}/api/UnitReleaseRA/GetUnits`,
  UNIT_RELEASE_RA_UNIT_INFO: `${BASEURL}/api/UnitReleaseRA/GetUnitInfo`,
  UNIT_RELEASE_RA_CANDIDATES: `${BASEURL}/api/UnitReleaseRA/GetCandidates`,
  UNIT_RELEASE_RA_SAVE: `${BASEURL}/api/UnitReleaseRA/ReleaseUnits`,
  UNIT_RELEASE_RA_LIST: `${BASEURL}/api/UnitReleaseRA/GetReleases`,

  // Agent Master
  AGENT_MASTER_LIST: `${AGENT_URL}/api/general/agentmaster/getlist`,
  AGENT_MASTER_SAVE: `${AGENT_URL}/api/general/agentmaster/save`,
  AGENT_MASTER_UPDATE: `${AGENT_URL}/api/general/agentmaster/update`,
  AGENT_MASTER_GET_BY_ID: `${AGENT_URL}/api/general/agentmaster/getbyid`,
  AGENT_MASTER_DOC_EXPIRY: `${AGENT_URL}/api/general/agentmaster/getdocumentexpiry`,
  AGENT_MASTER_DROPDOWNS: `${AGENT_URL}/api/general/agentmaster/loaddropdownsandgrids`,
};
